import React from "react";
import { Typography } from "@material-ui/core";
import InputWithStyle from "../../HOCs/InputWithStyle/InputWithStyle";
import ButtonWithStyle from "../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { useForm } from "react-hook-form";
import { connect } from "react-redux";
import { getUser } from "../../actions/users";

function AddStoreToUser({ user, getUser }) {
	const { register, handleSubmit } = useForm();

	const onSubmit = async ({ email }) => {
		getUser(email);
	};

	if (user.mail) {
		return <Typography variant="h6">{user.mail}</Typography>;
	}

	return (
		<form onSubmit={handleSubmit(onSubmit)}>
			<InputWithStyle
				fullWidth
				name="email"
				inputRef={register({ required: true })}
				label="Email a buscar"
				type="mail"
			/>
			<ButtonWithStyle type="submit">Buscar</ButtonWithStyle>
		</form>
	);
}

const mapStateToProps = ({ user = null }) => {
	return { user };
};
export default connect(mapStateToProps, { getUser })(AddStoreToUser);
